import PolicyDetailTravel from './PolicyDetailTravel';
export default PolicyDetailTravel;
